import { useState, useEffect } from "react";
import api from "@/lib/api";
import { ListTodo } from "lucide-react";

export function useOpenTaskCounts(enabled, byClient = false) {
  const [counts, setCounts] = useState({});
  useEffect(() => {
    if (!enabled) { return; }
    Promise.all([api.get("/tasks"), byClient ? api.get("/tenants") : Promise.resolve({ data: [] })]).then(([r, tr]) => {
      const t2c = Object.fromEntries((tr.data || []).map((t) => [t.id, t.client_id]));
      const c = {};
      (r.data || []).filter((t) => !t.done).forEach((t) => {
        const key = byClient ? (t2c[t.tenant_id] || t.client_id) : t.tenant_id;
        if (key) c[key] = (c[key] || 0) + 1;
      });
      setCounts(c);
    }).catch(() => {});
  }, [enabled, byClient]);
  return counts;
}

export const OpenTasksBadge = ({ n, tid }) => (
  <span className={`inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full ${n ? "bg-amber-100 text-amber-800" : "bg-slate-100 text-slate-500"}`} data-testid={`open-tasks-badge-${tid}`}>
    <ListTodo className="h-3 w-3" /> {n ? `${n} open ${n === 1 ? "taak" : "taken"}` : "Geen taken"}
  </span>
);
